/**
 * Lock --app-height on load. Update it on rotate and when window width
 * changes at scale 1 (browser zoom, desktop resize).
 * Toolbar show/hide and pinch-zoom must not change it.
 */
export function initMobileViewportInsets(): void {
  if (typeof window === "undefined") return;

  const root = document.documentElement;

  const apply = () => {
    root.style.setProperty("--app-height", `${window.innerHeight}px`);

    const vv = window.visualViewport;
    if (!vv || Math.abs(vv.scale - 1) > 0.01) return;

    const bottomInset = Math.max(
      0,
      Math.min(120, Math.round(window.innerHeight - vv.offsetTop - vv.height)),
    );

    root.style.setProperty(
      "--browser-bottom-inset",
      bottomInset > 0 ? `${bottomInset}px` : "0px",
    );
  };

  apply();

  let lastWidth = window.innerWidth;

  window.addEventListener("resize", () => {
    const vv = window.visualViewport;
    if (vv && Math.abs(vv.scale - 1) > 0.01) return;
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    apply();
  });

  window.addEventListener("orientationchange", () => {
    window.setTimeout(() => {
      lastWidth = window.innerWidth;
      apply();
    }, 300);
  });
}
